export const incentiveStatusQuery = `query IncentiveStatus($email:String!, $incentiveName:String!, $transactionStartDate:DateTime!, $transactionEndDate:DateTime!) {
  incentiveStatus(email:$email,incentiveName:$incentiveName, transactionStartDate: $transactionStartDate, transactionEndDate: $transactionEndDate)
  {
    valid
    transactionDate
    alreadyRegistered
    errors { message code }
  }
}`